module.exports = __webpack_public_path__ + "img/especialista4.32e6764e.png";